module.exports.IMPORT_COMPANY_ID = process.env.NODE_ENV == 'production' ? 37529 : 27981;

// EXT_VIEW_FUNCTIONS.{function_name}
module.exports.TYPE_FUNCTIONS = {
  biogasUpgrade: 'VERWZW_ID_BIOGASUPGRADE',
  heizgas: 'VERWZW_ID_HEIZGAS',
  heizgasProcess: 'VERWZW_ID_HEIZGAS_ENAW',
  verstromung: 'VERWZW_ID_STROM',
  muken: 'VERWZW_ID_MUKEN',
  // additional but only used to determine CanBuyImportedGases:
  _liqtk: 'VERWZW_ID_LIQTK',
  _biogasabgabe: 'VERWZW_ID_BIOGASABGABE',
};

// may not contain spaces
// dont forget to update webpack
module.exports.PRODUCTION_GASTYPES = [
  'BIOG',
  'H',
  'SG',
];
module.exports.IMPORT_BIOGAS_GASTYPES = [
  'IBGN',
  'IBGZ',
];
module.exports.IMPORT_LGG_GASTYPES_WITH_PROOF = [
  'LBGM',
  'LHM',
  'LSGM',
]
module.exports.IMPORT_LGG_GASTYPES_WITHOUT_PROOF = [
  'LBGO',
  'LHO',
  'LSGO'
]

module.exports.USAGE_GROUPS = [
  'verkauf',
  'verbrauch',
];

module.exports.PRODUCTION_GROUPS = [
  'lager',
  'einkauf',
  'import',
];

module.exports.IMPORT_LGG_GASTYPES = module.exports.IMPORT_LGG_GASTYPES_WITH_PROOF.concat(module.exports.IMPORT_LGG_GASTYPES_WITHOUT_PROOF);
module.exports.LGG_GASTYPE = "LGGTG";
module.exports.GASTYPES = module.exports.PRODUCTION_GASTYPES.concat(module.exports.IMPORT_BIOGAS_GASTYPES).concat(module.exports.IMPORT_LGG_GASTYPES);
module.exports.PRODUCTION_AND_IMPORT_GASTYPES = module.exports.PRODUCTION_GASTYPES.concat(module.exports.IMPORT_BIOGAS_GASTYPES);
module.exports.CERTIFICATE_PATH = "/tmp";
module.exports.CERTIFICATE_SUFFIX = "-certificate.pdf";
module.exports.CERTIFICATE_MAX_BYTES = 1000000;
module.exports.MAX_SIMULTANEOUS_SQL_REQUESTS = 25;
